const SiteEnum = {
  INTERNO: 8,
  THINK: 14
};

export default SiteEnum;



// WEBPACK FOOTER //
// ./src/domain/web/SiteEnum.js